import { FormInputProps } from "../../utils/types";

export const FormInput = (props: FormInputProps) => {
    const { id, type, error, onChange, value, label, autofocus, required, icon } = props;

    return (
        <div className={icon ? "form-group-icon" : "form-group"}>
            {/* {icon && <i>{icon}</i>} */}
            <input
                id={id}
                className={error ? "form-input-error" : icon ? "form-input-icon" : "form-input"}
                name={id}
                placeholder={label}
                type={type}
                onChange={e => {
                    onChange(e);
                }}
                value={value}
                autoFocus={autofocus ? autofocus : false}
                required={required ? required : false}
            />
        </div>
    );
};
